import gql from 'graphql-tag';

const GET_ORDERS = gql`query getOrdersFeed(
    $size: Int
    $page: Int
    $sort: [SortInput]
    $filters: [FilterInput]
    $range: [RangeInput]
    $sendToExport: String
    $typeReport: Int
    $fromRoomManagement: Boolean
  ) {
    orders(
      filters: $filters
      size: $size
      page: $page
      sort: $sort
      range: $range
      sendToExport: $sendToExport
      typeReport: $typeReport
      fromRoomManagement: $fromRoomManagement
    ) {
      count
      page
      results {
        ... on Order {
          items {
            id
            name
            quantity
            unit
          }
          pickerInfo {
            email
            name
            lastName
          }
          pickingInfo {
            status {
              code
              label
            }

            posDetail {
              date
              hour
            }
  
            pickingStats {
              quantityRequested
              quantityPicked
              fillRate
            }
          }
          id
          courierName
          shippingChange
          createdAt
          itemCount
          skuCount
          split
          storeName
          salesChannelId
          extIssueIsDelayed
          extIssueDelayedByQueuing
          substitutionType {
            label
            code
          }
          selectedAddress {
            addressLine
            neighborhood
            receiverName
            receiverDocument
            geoCoordinates
          }
          paymentData {
            transactions {
                payments {
                    amount
                }
            }
          }
          logisticsInfo {
            selectedSla
            shippingEstimateDate
            shippingEstimate
            deliveryWindow {
              price
              startDateUtc
              endDateUtc
            }
            shippingETA
            shippingETAend
            deliveryAverage
          }
          customer {
            email
            lastName
            fullName
            firstName
            document
            phone
            isVIP
            isUltraVIP
            isCencoPrime
          }
          windowAnticipated
          ordersBipicking
          isPersonalShopperCustomer
        }
      }
    }
  }
  `;

export default GET_ORDERS;